var n = /* @__PURE__ */ ((e) => (e.Ascending = "ascending", e.Descending = "descending", e))(n || {});
export {
  n as SortDirectionEnum
};
//# sourceMappingURL=sort.js.map
